import * as React from 'react';
import { FunctionComponent } from 'react';
import { WPBlockProps } from './types';

const WpHeading: FunctionComponent<WPBlockProps> = ({
  block,
}): React.ReactElement | null => {
  const innerHTML = block.saveContent || block.originalContent;
  if (!innerHTML) {
    return null;
  }

  return (
    <div
      className="wp-heading-block"
      dangerouslySetInnerHTML={{
        __html: innerHTML,
      }}
      onClick={(event: React.MouseEvent) => {
        // hack to give the click event to a link (a-Element)
        // within the childnodes of the event-target
        const children = (event.target as any).childNodes;
        const array = [...children];
        array.forEach((elem) => {
          if (elem.nodeName === 'A') {
            elem.click();
          }
        });
      }}
    />
  );
};

export default WpHeading;
